import { Route, Routes } from "react-router-dom";
import PurchaseOrderDeliverPage from "./PurchaseOrderDeliverPage";
import PurchaseOrderPage from "./PurchaseOrderPage";
import PurchaseOrdersPage from "./PurchaseOrdersPage";

const PurchasePages = () => {
  return (
    <Routes>
      <Route index element={<PurchaseOrdersPage />} />
      <Route path=":odooCompanyId/:id" element={<PurchaseOrderPage />} />
      <Route
        path=":odooCompanyId/:id/deliver"
        element={<PurchaseOrderDeliverPage />}
      />
    </Routes>
  );
};

export default PurchasePages;
